import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import swal from "sweetalert";
import globalStyle from "../../../globalStyle";
import AddConfirmDialog from "../../clients/team/AddedConfirmDialog";

const startTimee = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
  "23:59",
];

const OpeningHours = ({
  open,
  type,
  setOpen,
  selectedDays,
  setSelectedDays,
  openConfirmDialog,
  completeBranchData,
  handleCreateTeamMember,
  handleFetchBranhDetails,
}) => {
  useEffect(() => {
    if (type == "team") {
      handleFetchBranhDetails();
    }
  }, []);

  console.log(completeBranchData, "selectedDaysselectedDaysselectedDays");

  const showAlert = () => {
    swal({
      title: "Selection Not Allowed!",
      icon: "warning",
      button: "Okay",
      content: {
        element: "div",
        attributes: {
          innerHTML: `<p style="text-align: center; font-size: 16px; font-weight: 500;">
            Branch is closed on this day, so you cannot select it while creating a team.
          </p>`,
        },
      },
    });
  };

  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={10}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "25px", marginBottom: "15px" }}
          >
            Add your opening hours
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "400", fontSize: "15px", marginBottom: "15px" }}
          >
            Let clients know your standard opening hours. These will be
            displayed on your profile but do not affect your appointments
            calendar.
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "20px",
            }}
          >
            {selectedDays?.map((item, index) => (
              <Box
                key={item.name}
                onClick={() => {
                  if (type === "team") {
                    const isAllowed = completeBranchData?.timmings?.some(
                      (branchDay) =>
                        branchDay?.name === item.name && branchDay?.selected
                    );

                    if (!isAllowed) return showAlert();

                    const updatedDays = JSON.parse(
                      JSON.stringify(selectedDays)
                    );
                    updatedDays[index].selected = !updatedDays[index].selected;
                    updatedDays[index].startTime =
                      completeBranchData?.timmings[index].startTime;
                    updatedDays[index].endTime =
                      completeBranchData?.timmings[index].endTime;
                    setSelectedDays(updatedDays);
                  } else {
                    let tempArrr = selectedDays?.map((day, idx) =>
                      idx === index ? { ...day, selected: !day.selected } : day
                    );
                    setSelectedDays(tempArrr);
                  }
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: item.selected ? "#EA580C" : "none",
                  height: "40px",
                  width: "40px",
                  marginRight: "15px",
                  borderRadius: "50%",
                  padding: "10px",
                  border: "1px solid #f2f2f2",
                  cursor: "pointer",
                }}
              >
                <Typography
                  sx={{
                    color: item.selected ? "#fff" : "black",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  {item.name.slice(0, 3)}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Time pickers for selected days */}
          {selectedDays?.map((day, index) => {
            if (!day.selected) return null;

            return (
              <Box key={index} sx={{ width: "100%", marginBottom: "15px" }}>
                <Grid container alignItems={"center"}>
                  <Grid item xs={3}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: "700",
                        fontSize: "15px",
                        marginBottom: "1px",
                      }}
                    >
                      {day.name}
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{ fontWeight: "400", fontSize: "13px" }}
                    >
                      Open
                    </Typography>
                  </Grid>

                  {/* Start Time Dropdown */}
                  <Grid item xs={3}>
                    <FormControl fullWidth sx={globalStyle.selectType}>
                      <Select
                        placeholder="From"
                        displayEmpty
                        variant="outlined"
                        size="small"
                        value={day.startTime}
                        onChange={(e) => {
                          // const updatedDays = [...selectedDays];
                          // updatedDays[index].startTime = e.target.value;
                          // setSelectedDays(updatedDays);

                          setSelectedDays(
                            selectedDays.map((valiiii, indiiii) => {
                              if (indiiii == index)
                                return {
                                  ...valiiii,
                                  startTime: e.target.value,
                                };
                              return valiiii;
                            })
                          );
                        }}
                      >
                        {type == "team"
                          ? (() => {
                              const branchStartIdx = startTimee.indexOf(
                                completeBranchData?.timmings?.[index]?.startTime
                              );
                              const endIdx = startTimee.indexOf(day?.endTime);
                              let options = [];
                              if (endIdx > branchStartIdx) {
                                options = startTimee.slice(branchStartIdx, endIdx);
                              } else {
                                // Wrap around midnight
                                options = [
                                  ...startTimee.slice(branchStartIdx),
                                  ...startTimee.slice(0, endIdx),
                                ];
                              }
                              return options.map((val) => (
                                <MenuItem key={val} value={val}>
                                  {val}
                                </MenuItem>
                              ));
                            })()
                          : startTimee.map((val) => (
                              <MenuItem key={val} value={val}>
                                {val}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={1} sx={{ textAlign: "center" }}>
                    <Typography>To</Typography>
                  </Grid>

                  {/* End Time Dropdown */}
                  <Grid item xs={3}>
                    <FormControl fullWidth sx={globalStyle.selectType}>
                      <Select
                        placeholder="To"
                        displayEmpty
                        variant="outlined"
                        size="small"
                        value={day.endTime}
                        onChange={(e) => {
                          // Error
                          // const updatedDays = [...selectedDays];
                          // updatedDays[index].endTime = e.target.value;
                          // setSelectedDays(updatedDays);

                          // FIX #1
                          const updatedDays = JSON.parse(
                            JSON.stringify(selectedDays)
                          );
                          updatedDays[index].endTime = e.target.value;
                          setSelectedDays(updatedDays);

                          // FIX #2
                          // const updatedDays = [...selectedDays];
                          // const day = {
                          //   ...updatedDays[index],
                          //   endTime: e.target.value,
                          // };
                          // updatedDays[index] = day;
                          // setSelectedDays(updatedDays);

                          // FIX #3
                          // setSelectedDays(
                          //   selectedDays.map((valiiii, indiiii) => {
                          //     if (indiiii == index)
                          //       return {
                          //         ...valiiii,
                          //         endTime: e.target.value,
                          //       };
                          //     return valiiii;
                          //   })
                          // );
                        }}
                      >
                        {type == "team"
                          ? (() => {
                              const startIdx = startTimee.indexOf(day?.startTime);
                              const endIdx = startTimee.indexOf(
                                completeBranchData?.timmings?.[index]?.endTime
                              );
                              let options = [];
                              if (endIdx > startIdx) {
                                options = startTimee.slice(startIdx + 1, endIdx + 1);
                              } else {
                                // Wrap around midnight
                                options = [
                                  ...startTimee.slice(startIdx + 1),
                                  ...startTimee.slice(0, endIdx + 1),
                                ];
                              }
                              return options.map((val) => (
                                <MenuItem key={val + "0"} value={val}>
                                  {val}
                                </MenuItem>
                              ));
                            })()
                          : startTimee.map((val) => (
                              <MenuItem key={val + "0"} value={val}>
                                {val}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            );
          })}
        </Grid>
      </Grid>

      {/* Confirmation Dialog for Team */}
      {type === "team" && (
        <AddConfirmDialog
          open={open}
          setOpen={setOpen}
          ref={openConfirmDialog}
          handleCreateTeamMember={handleCreateTeamMember}
        />
      )}
    </Box>
  );
};

export default OpeningHours;
